import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { DatePipe } from '@angular/common';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { EnumIdsTcEstadoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';
import { EnumCodigosTwTcAcciones, EnumIdsTwTcTipoClonacion } from '../../../_importacion/solicitudes/types/enum';
import { HttpParams } from '@angular/common/http';
import { DocumentUploaderService } from '../../../core/components/uploader/document-uploader.service';
import { UploadedFileViewModel } from '../../../core/components/uploader/document_uploader.types';
import { AlegacionExViewModel } from './alegacionEx.types';
import { AlegacionExService } from './alegacionEx.service';
import { TDocumentoSolicitudExViewModel } from '../documentos/documentosEx.types';

@Component({
    selector: 'app-alegacionex',
    templateUrl: './alegacionEx.component.html',
})
export class AlegacionExComponent extends ComponentBase implements OnInit {
    alegacionEx: AlegacionExViewModel;
    uploadedFile: UploadedFileViewModel;

    documentosAlegaciones: TDocumentoSolicitudExViewModel[];
    habilitarGuardar = false;
    habilitarNuevoDocumento = false;
    numeroDocumentos = 0;
    cols: any[];
    //id: number = 0;
    editMode = false;
    tituloTipoSolicitudEx: string;
    documentoDescargable = false;
    documentoBorrable = false;
    visibilitySpinner = false;
    esClonada = false;
    ObservacionesAlegacion: string;
    ObservacionesDecision: string;
    Decision: boolean | null;
    FechaRechazo: Date;
    laHeGrabadoYo = false;
    haceDeGrabador = false;
    idSolicitudEx: number;
    IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    IdSubTipoSolicitudEx: number | null;
    IdSubTipoSolicitudExDescripcion: string;
    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        private alegacionExService: AlegacionExService,
        private confirmationService: ConfirmationService,
        private uploaderService: DocumentUploaderService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.alegacionEx = new AlegacionExViewModel();
        this.uploadedFile = new UploadedFileViewModel();
    }

    ngOnInit() {
        this.idSolicitudEx = +this.activatedRoute.snapshot.params['id'];

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'NombreArchivo', header: 'Nombre Archivo' },
            { field: 'Fecha', header: 'Fecha' },
        ];

        //this.id = this.activatedRoute.snapshot.params["id"];

        this.guardRefreshPage(this.idSolicitudEx);

        this.createForm();

        this.loading = true;

        //Para saber si se actua como Inspector o Grabador
        let params = new HttpParams();
        params = params.append('idSolicitudEx', this.idSolicitudEx.toString());
        params = params.append('idUsuario', this.loggedInUser!.Id.toString());
        this.solicitudExService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
            this.laHeGrabadoYo = resultIsGrabada;

            this.alegacionExService.getAlegacionEx(this.idSolicitudEx).subscribe(result => {
                this.alegacionEx = result;

                this.tituloTipoSolicitudEx = this.alegacionEx.IdTipoSolicitudExDescripcion;
                this.esClonada =
                    this.alegacionEx.TwSolicitudJerarquiaEx != null &&
                    this.alegacionEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;

                this.ObservacionesAlegacion = this.alegacionEx.ObservacionesAlegacion;
                this.ObservacionesDecision = this.alegacionEx.ObservacionesDecision;
                this.Decision = this.alegacionEx.Decision;
                this.FechaRechazo = this.alegacionEx.FechaRechazo;

                //SI ES PREVIA
                if (this.alegacionEx.EsPrevia) {
                    if (
                        this.alegacionEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                        this.alegacionEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitudEx += '-Previa';
                    }
                }

                //Filtro los documentos que son de alegaciones
                this.documentosAlegaciones = this.alegacionEx.TDocumentoSolicitudExCollection.filter(x => x.EsAlegacion == true);
                this.numeroDocumentos = this.documentosAlegaciones!.length;

                //el icono de descargar aparecerá siempre que exista algún documento. La edición se gestiona a continuación
                this.documentoDescargable = this.numeroDocumentos > 0;

                this.updateForm();

                //Si soy Inspector-Grabador y la solicitud la grabé yo
                if (this.isGrabador && this.isInspector && this.laHeGrabadoYo) {
                    //Si no se ha guardado alegacion entonces hace de GRABADOR
                    if (this.alegacionEx.FechaAlegacion == null) {
                        this.haceDeGrabador = true;

                        //calculo la fecha maxima de alegaciones
                        let fechaMaxAlegacion = new Date(this.alegacionEx.FechaRechazo);
                        let fechaHoy = new Date();
                        fechaMaxAlegacion.setDate(fechaMaxAlegacion.getDate() + 10);

                        if (fechaMaxAlegacion < fechaHoy) {
                            this.addInfoMessage('Se ha superado el plazo para presentar alegaciones');

                            this.form.controls['ObservacionesAlegacion'].disable();
                            this.form.controls['ObservacionesDecision'].disable();
                            this.form.controls['Decision'].disable();
                            this.habilitarGuardar = false;
                            this.habilitarNuevoDocumento = false;
                        } else {
                            this.addValidator('ObservacionesAlegacion', Validators.required);
                            this.form.controls['ObservacionesDecision'].disable();
                            this.form.controls['Decision'].disable();

                            this.habilitarGuardar = this.loggedInUser!.getAction(
                                EnumCodigosTwTcAcciones.MENU_ALEGACIONES,
                                this.alegacionEx.IdEstadoSolicitudEx,
                            ).Editable;
                            this.habilitarNuevoDocumento = this.loggedInUser!.getAction(
                                EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_ALEGACIONES,
                                this.alegacionEx.IdEstadoSolicitudEx,
                            ).Visible;

                            if (!this.habilitarGuardar) {
                                this.form.controls['ObservacionesAlegacion'].disable();
                            }
                        }
                    }
                    //En otro caso, hace de INSPECTOR
                    else {
                        this.haceDeGrabador = false;

                        this.form.controls['ObservacionesAlegacion'].disable();
                        this.habilitarNuevoDocumento = false;
                        //Si ya se ha guardado la Decisión
                        if (this.alegacionEx.Decision != null) {
                            this.habilitarGuardar = false;
                            this.form.controls['ObservacionesDecision'].disable();
                            this.form.controls['Decision'].disable();
                        } else {
                            //Si el solicitante ha puesto alegación
                            if (this.alegacionEx.ObservacionesAlegacion != null) {
                                this.habilitarGuardar = this.loggedInUser!.getAction(
                                    EnumCodigosTwTcAcciones.MENU_ALEGACIONES,
                                    this.alegacionEx.IdEstadoSolicitudEx,
                                ).Editable;
                                this.addValidator('ObservacionesDecision', Validators.required);
                                this.addValidator('Decision', Validators.required);

                                this.form.controls['ObservacionesDecision'].enable();
                                this.form.controls['Decision'].enable();
                            }
                        }

                        if (!this.habilitarGuardar) {
                            this.form.controls['ObservacionesDecision'].disable();
                            this.form.controls['Decision'].disable();
                        }
                    }

                    //this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_ALEGACIONES, this.alegacionEx.IdEstadoSolicitudEx).Visible && this.laHeGrabadoYo;

                    this.documentoBorrable = this.checkDelete() && this.laHeGrabadoYo;
                }
                //En otros casos
                else {
                    if (this.isSolicitante || (this.isGrabador && !this.isInspector)) {
                        //calculo la fecha maxima de alegaciones
                        let fechaMaxAlegacion = new Date(this.alegacionEx.FechaRechazo);
                        let fechaHoy = new Date();
                        fechaMaxAlegacion.setDate(fechaMaxAlegacion.getDate() + 10);

                        if (fechaMaxAlegacion < fechaHoy) {
                            this.addInfoMessage('Se ha superado el plazo para presentar alegaciones');

                            this.form.controls['ObservacionesAlegacion'].disable();
                            this.form.controls['ObservacionesDecision'].disable();
                            this.form.controls['Decision'].disable();
                            this.habilitarGuardar = false;
                            this.habilitarNuevoDocumento = false;
                        } else {
                            this.addValidator('ObservacionesAlegacion', Validators.required);
                            this.form.controls['ObservacionesDecision'].disable();
                            this.form.controls['Decision'].disable();
                            //Si el Solicitante no ha guardado alegacion
                            if (this.alegacionEx.FechaAlegacion == null) {
                                this.habilitarGuardar = this.loggedInUser!.getAction(
                                    EnumCodigosTwTcAcciones.MENU_ALEGACIONES,
                                    this.alegacionEx.IdEstadoSolicitudEx,
                                ).Editable;
                                this.habilitarNuevoDocumento = this.loggedInUser!.getAction(
                                    EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_ALEGACIONES,
                                    this.alegacionEx.IdEstadoSolicitudEx,
                                ).Visible;
                            }
                            //Si el Solicitante ha intervenido
                            else {
                                this.habilitarGuardar = false;
                                this.habilitarNuevoDocumento = false;
                            }

                            if (!this.habilitarGuardar) {
                                this.form.controls['ObservacionesAlegacion'].disable();
                            }
                        }
                    } else if (this.isInspector) {
                        this.form.controls['ObservacionesAlegacion'].disable();
                        this.habilitarNuevoDocumento = false;
                        //Si ya se ha guardado la Decisión
                        if (this.alegacionEx.Decision != null) {
                            this.habilitarGuardar = false;
                            this.form.controls['ObservacionesDecision'].disable();
                            this.form.controls['Decision'].disable();
                        } else {
                            //Si el solicitante ha puesto alegación
                            if (this.alegacionEx.ObservacionesAlegacion != null) {
                                this.habilitarGuardar = this.loggedInUser!.getAction(
                                    EnumCodigosTwTcAcciones.MENU_ALEGACIONES,
                                    this.alegacionEx.IdEstadoSolicitudEx,
                                ).Editable;
                                this.addValidator('ObservacionesDecision', Validators.required);
                                this.addValidator('Decision', Validators.required);
                            }
                            //Si el solicitante NO ha puesto alegación
                            else {
                                this.habilitarGuardar = false;
                                this.form.controls['ObservacionesDecision'].disable();
                                this.form.controls['Decision'].disable();
                            }
                        }

                        if (!this.habilitarGuardar) {
                            this.form.controls['ObservacionesDecision'].disable();
                            this.form.controls['Decision'].disable();
                        }
                    }

                    this.documentoBorrable = this.checkDelete();
                }

                //estos perfiles siempre podrán descargar documentos
                if (this.isInspector || this.isCoordinador) {
                    this.documentoDescargable = true;
                }

                this.loading = false;
            });
        });
    }

    //checkEdit() {

    //    return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_ALEGACIONES, this.alegacionEx.IdEstadoSolicitudEx).Editable;
    //}

    checkDelete() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_ALEGACIONES, this.alegacionEx.IdEstadoSolicitudEx).Visible;
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            FechaRechazo: null,
            ObservacionesAlegacion: '',
            FechaAlegacion: null,
            Decision: null,
            ObservacionesDecision: '',
            FechaDecision: null,
        });
    }

    updateForm() {
        this.form.setValue({
            FechaRechazo: this.datepipe.transform(this.alegacionEx.FechaRechazo, 'dd/MM/yyyy'),
            ObservacionesAlegacion: this.alegacionEx.ObservacionesAlegacion,
            FechaAlegacion: this.datepipe.transform(this.alegacionEx.FechaAlegacion, 'dd/MM/yyyy'),
            Decision: this.alegacionEx.Decision == true ? 'S' : this.alegacionEx.Decision == false ? 'N' : null,
            ObservacionesDecision: this.alegacionEx.ObservacionesDecision,
            FechaDecision: this.datepipe.transform(this.alegacionEx.FechaDecision, 'dd/MM/yyyy'),
        });
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/datosbasicosEx', this.navMenuService.currentSolicitudExportacion.Id]);
    }

    onAdd() {
        this.router.navigate([this.router.url, 'create']);
    }

    //onEdit(item: TwDocumentoAlegacionExViewModel) {

    //    this.router.navigate([this.router.url, "detalleDocumento", item.Id]);
    //}

    onDownload(item: TDocumentoSolicitudExViewModel) {
        this.uploadedFile.Guid = item.CodigoStorage;
        this.uploadedFile.Name = item.NombreArchivo;

        this.uploaderService.download(this.uploadedFile).subscribe(res => {
            this.OpenDownloadedFile(res);
        });
    }

    onDelete(item: TDocumentoSolicitudExViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.alegacionExService.deleteDocumento(item.Id).subscribe(() => {
                    this.addSuccessMessage('Documento eliminado correctamente');
                    this.ngOnInit();
                });
            },
        });
    }

    guardarAlegacion() {
        if (this.isSolicitante) {
            this.confirmationService.confirm({
                message: '¿Está seguro de guardar la alegación actual?.',
                accept: () => {
                    this.onSubmit();
                },
            });
        } else {
            this.confirmationService.confirm({
                message: '¿Está seguro de guardar la decisión?.',
                accept: () => {
                    this.onSubmit();
                },
            });
        }
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        let alegacionEx = new AlegacionExViewModel();
        alegacionEx.IdSolicitudEx = this.alegacionEx.IdSolicitudEx;

        alegacionEx.ObservacionesAlegacion =
            this.form.value.ObservacionesAlegacion != null ? this.form.value.ObservacionesAlegacion : this.ObservacionesAlegacion;
        alegacionEx.ObservacionesDecision = this.form.value.ObservacionesDecision != null ? this.form.value.ObservacionesDecision : this.ObservacionesDecision;
        alegacionEx.Decision =
            this.form.value.Decision != null ? (this.form.value.Decision == 'S' ? true : this.form.value.Decision == 'N' ? false : null) : this.Decision;
        alegacionEx.FechaRechazo = this.FechaRechazo;

        if (this.isInspector && this.isGrabador && this.laHeGrabadoYo) {
            if (this.haceDeGrabador) {
                //Siempre será EDIT aqui, el insert se hace al rechazar la inspección
                this.alegacionExService.editAlegacionEx(alegacionEx).subscribe({
                    next: () => {
                        this.addSuccessMessage('Alegación guardada correctamente');
                        //this.onBack();
                        this.visibilitySpinner = false;
                        this.ngOnInit();
                    },
                    error: error => {
                        this.catchServerError(error);
                        this.visibilitySpinner = false;
                    },
                });
            } else {
                //Siempre será EDIT aqui, el insert se hace al rechazar la inspección
                this.alegacionExService.editAlegacionEx(alegacionEx).subscribe({
                    next: () => {
                        this.addSuccessMessage('Decisión guardada correctamente');
                        //this.onBack();
                        this.visibilitySpinner = false;
                        this.ngOnInit();
                    },
                    error: error => {
                        this.catchServerError(error);
                        this.visibilitySpinner = false;
                    },
                });
            }
        } else {
            if (this.isSolicitante || this.isGrabador) {
                //Siempre será EDIT aqui, el insert se hace al rechazar la inspección
                this.alegacionExService.editAlegacionEx(alegacionEx).subscribe({
                    next: () => {
                        this.addSuccessMessage('Alegación guardada correctamente');
                        //this.onBack();
                        this.visibilitySpinner = false;
                        this.ngOnInit();
                    },
                    error: error => {
                        this.catchServerError(error);
                        this.visibilitySpinner = false;
                    },
                });
            } else {
                //Siempre será EDIT aqui, el insert se hace al rechazar la inspección
                this.alegacionExService.editAlegacionEx(alegacionEx).subscribe({
                    next: () => {
                        this.addSuccessMessage('Decisión guardada correctamente');
                        //this.onBack();
                        this.visibilitySpinner = false;
                        this.ngOnInit();
                    },
                    error: error => {
                        this.catchServerError(error);
                        this.visibilitySpinner = false;
                    },
                });
            }
        }
    }
}
